/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useCallback, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { NAV_PAGE_LIST, NAV_PAGE_LIST_ICEPACKS, TABLE_COLUMNS } from './constants';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { getIcepacksSelector, getIsIcepacksLoadingSelector, getPaginationSelector } from './selectors';
import { getIcepacksAction, resetStateAction } from './actions';
import { getIsAvailableIcepacksButtonsSelector } from '../profile/selectors';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { DataGridComponent } from '../../components/data-grid';
import { normalizeDataGridModel } from '../../utils/normalizeDataGridModel';
import { PageContentWithNav } from '../../components/page-content-with-nav';

const IcepacksContainerWrapper = ({
	onGetIcepacks,
	icepacks,
	isIcepacksLoading,
	pagination,
	onResetState,
	isAvailable,
}) => {
	useInjectSaga({ key: 'icepacksContainerSaga', saga });
	useInjectReducer({ key: 'icepacksContainerReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		onGetIcepacks({ searchQuery: removeModalQuery(query.toString()) });

		return () => onResetState();
	}, []);

	const handleAddButtonClick = () => {
		query.set('modal', 'icepack');
		query.set('mode', 'add');

		history.push(`${pathname}?${query}`);
	};

	const handlePageChange = (_, { activePage }) => {
		query.set('page', activePage);

		history.push(`${pathname}?${query}`);

		onGetIcepacks({ searchQuery: removeModalQuery(query.toString()) });
	};

	const handleSelectChange = (_, { value }) => {
		query.set('page', 1);

		if (value === 'all') {
			query.delete('per_page');
		} else {
			query.set('per_page', value);
		}

		history.push(`${pathname}?${query}`);

		onGetIcepacks({ searchQuery: removeModalQuery(query.toString()) });
	};

	const handleSortChange = useCallback(sortModel => {
		const jsonSorts = JSON.stringify(sortModel);

		query.set('sorts', jsonSorts);

		history.push(`${pathname}?${query}`);

		onGetIcepacks({ searchQuery: removeModalQuery(query.toString()) });
	});

	const handleFilterChange = useCallback((filterModel, action) => {
		if (action.reason) {
			const jsonFilters = JSON.stringify(normalizeDataGridModel(filterModel, TABLE_COLUMNS));

			query.delete('page');
			query.set('filters', jsonFilters);

			history.push(`${pathname}?${query}`);

			onGetIcepacks({ searchQuery: removeModalQuery(query.toString()) });
		}
	});

	return (
		<PageContentWithNav
			pageNavigationItems={NAV_PAGE_LIST}
			isInnerRouter
			pageContent={
				<PageContentWithNav
					pageNavigationItems={NAV_PAGE_LIST_ICEPACKS}
					isInnerRouter
					pageContent={
						<DataGridComponent
							headerText="Хладоэлементы"
							columns={TABLE_COLUMNS}
							style={pagination ? { height: 'calc(100vh - 344px)' } : { height: 'calc(100vh - 287px)' }}
							onAddButtonClick={isAvailable.create ? handleAddButtonClick : null}
							rows={icepacks}
							pagination={
								!pagination
									? null
									: {
											...pagination,
											onPageChange: handlePageChange,
											onSelectChange: handleSelectChange,
									  }
							}
							isTableDataLoading={isIcepacksLoading}
							handleSortChange={handleSortChange}
							handleFilterChange={handleFilterChange}
						/>
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	icepacks: getIcepacksSelector(),
	isIcepacksLoading: getIsIcepacksLoadingSelector(),
	pagination: getPaginationSelector(),
	isAvailable: getIsAvailableIcepacksButtonsSelector(),
});

const mapDispatchToProps = {
	onGetIcepacks: getIcepacksAction,
	onResetState: resetStateAction,
};

const IcepacksContainer = connect(mapStateToProps, mapDispatchToProps)(IcepacksContainerWrapper);

IcepacksContainerWrapper.propTypes = {
	onGetIcepacks: PropTypes.func.isRequired,
	icepacks: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string,
			link: PropTypes.string.isRequired,
		}),
	),
	isIcepacksLoading: PropTypes.bool.isRequired,
	pagination: PropTypes.shape({
		currentPage: PropTypes.number,
		totalPages: PropTypes.number.isRequired,
		total: PropTypes.number,
		from: PropTypes.number,
		to: PropTypes.number,
		isNextItem: PropTypes.bool,
		isPrevItem: PropTypes.bool,
		isFirstItem: PropTypes.bool,
		isLastItem: PropTypes.bool,
	}),
	onResetState: PropTypes.func.isRequired,
	isAvailable: PropTypes.objectOf(PropTypes.bool),
};

export default IcepacksContainer;
